import { useEffect, useState, useRef } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import { answerQuery, answerQueryAgain } from '../../store/knownDataSlice';
import { unwrapResult } from '@reduxjs/toolkit';
import TextareaAutosize from 'react-textarea-autosize';
import { DataContainer } from '../../components/DataContainer';
import { default as FNS } from '../../api';

function AnswerQuery({ id, secondTime = false }) {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const data = useSelector((state) => state.knownData[id]);
    const [ tax, setTax ] = useState("24");
    const [ price, setPrice ] = useState(0);
    const [ logisticsNotes, setLogisticsNotes ] = useState("");
    const [ isSending, setIsSending ] = useState(false);

    async function onSubmit() {
        setIsSending(true);
        const res = await unwrapResult(await dispatch((secondTime ? answerQueryAgain : answerQuery)({
            id,
            tax,
            logisticsNotes,
            price,
        })));
        setIsSending(false);
        if(!res) return;

        navigate("/platform/answeredQuery/" + id);
        toast.success("E-kiri saadetud!");
    }

    if(!data) return;

    return (
        <DataContainer actionTypes={[ "knownData/answerQuery", "knownData/answerQueryAgain" ]}>
            <hr />

            <div className="column g32">
                <h2>Vasta päringule{secondTime ? " uuesti" : ""}</h2>

                <div className="column g8">
                    <p>Käibemaks</p>
                    <select value={tax} onChange={(e) => setTax(e.target.value)}>
                        <option value="22">22%</option>
                        <option value="24">24%</option>
                        <option value="0">0%</option>
                    </select>
                </div>

                <div className="column g8">
                    <p>Maksumus</p>
                    <input type="number" step={1} name="" id="" placeholder='123.45' value={price} onChange={(e) => setPrice(e.target.value)} />
                </div>

                <div className="column g8">
                    <p>"Pane tähele" tekst</p>
                    <TextareaAutosize placeholder='Tühjaks jättes on see sektsioon meilist peidetud. Enter uue rea jaoks' style={{ resize: 'none' }} minRows={3} value={logisticsNotes} onChange={(e) => setLogisticsNotes(e.target.value)} />
                </div>

                <button onClick={onSubmit} disabled={isSending}>Saada e-kiri</button>
            </div>
        </DataContainer>
    );
}

export default AnswerQuery;